import { render } from "./Pagine.vue?vue&type=template&id=7a311606"
import script from "./Pagine.vue?vue&type=script&lang=js"
export * from "./Pagine.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__